import React from 'react';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { BaseFilter, BaseFilterProps } from '../../common/BaseFilter';
import { CustomFieldEntitySubType, CustomFieldUtil } from '../../../../../types/custom_field';
import {
  CustomFieldEntitySubTypeFilterDropdownContent,
  CustomFieldEntitySubTypeFilterInnerContent,
} from './DropdownContent';
import { itemsContainText } from '../../../../../util/string.util';

export class CustomFieldEntitySubTypeFilter extends BaseFilter<CustomFieldEntitySubType> {
  toLabel(): string {
    return t(TranslationKey.entitySubtype).singular.label;
  }

  toIcon(): React.JSX.Element {
    return <></>;
  }

  toDropdownContent(props: BaseFilterProps): React.JSX.Element {
    return (
      <CustomFieldEntitySubTypeFilterDropdownContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <CustomFieldEntitySubTypeFilterInnerContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  search(item: CustomFieldEntitySubType, query: string): boolean {
    return itemsContainText(query, [item, CustomFieldUtil.customFieldEntitySubtypeToString(item)]);
  }

  toCount(): number {
    return 0;
  }
}
